module.exports = __webpack_public_path__ + "img/ui_task.b1314cec.jpg";